/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const recipients = {
  	index: 		r => require.ensure([], () => r(require('./components/recipient')), 'recipient-bundle'),
	imports: 	r => require.ensure([], () => r(require('./components/import')), 	'recipient-bundle'),
	edit: 	r => require.ensure([], () => r(require('./components/edit')), 	'recipient-bundle'),
	suppressionlist: 	r => require.ensure([], () => r(require('./components/suppressionlist')), 	'recipient-bundle'),
	suppression:{
		imports: 	r => require.ensure([], () => r(require('./components/suppressionimport')), 	'recipient-bundle'),
	}
};


export default [
    {
		name: 'recipients',
		path: '/recipients',
		component: recipients.index,
    },
    {
		name: 'suppression',
		path: '/suppression',
		component: recipients.suppressionlist,
    },
    {
		name: 'recipients.imports',
		path: '/import/recipients',
		component: recipients.imports,
    },
    {
		name: 'recipients.suppression.imports',
		path: '/imports/suppression',
		component: recipients.suppression.imports,
    },
    {
		name: 'recipients.edit',
		path: '/recipients/:id',
		component: recipients.edit,
    }
]





// WEBPACK FOOTER //
// ./src/app/recipient/routes.js